import { useEffect, useState } from "react";

function testWebpSupport(callback) {
  var useWebP = false;
  var elm = document.createElement("img");
  elm.setAttribute(
    "src",
    "data:image/webp;base64,UklGRjIAAABXRUJQVlA4ICYAAACyAgCdASoBAAEALmk0mk0iIiIiIgBoSygABc6zbAAA/v56QAAAAA=="
  );
  elm.onload = function () {
    useWebP = elm.width === 1 && elm.height === 1;
    callback(true);
  };
  elm.onerror = function () {
    callback(false);
  };
}

const useFixWebp = () => {
  //why true by default? since 95% of browsers support webp
  const [supportOrNot, setSupportOrNot] = useState(true);
  useEffect(() => {
    testWebpSupport((yesOrNo) => {
      setSupportOrNot(yesOrNo);
    });
  }, []);

  useEffect(() => {
    if (!supportOrNot) {
      const t = setInterval(() => {
        document.querySelectorAll('img[src*=".webp"]').forEach((it) => {
          if (it.getAttribute("data-src-webp-fallback")) {//specisal only for ol-images
            it.setAttribute("src", it.getAttribute("data-src-webp-fallback"));
          } else {
            const dType = it.getAttribute("data-type") || 'jpg'
            it.setAttribute(
              "src",
              it.getAttribute("src").replace(".webp", `.${dType}`)
            );
          }
        });
      }, 100);
      return () => clearInterval(t);
    }
  }, [supportOrNot]);
};

export default useFixWebp;
